import { Chip, Tooltip } from '../../ds';
import type { RenderMode } from '../../astromark';

const MODE_NAME: Record<RenderMode, string> = { auto: 'Auto', 'markdown-it': 'Markdown', astromark: 'AstroMark' };

/**
 * The top bar's override chip (after the space chip), shown only while the renderer is forced: a warning `Chip` inside a
 * button that resets the mode to `auto` (`ds.css` "render mode chip").
 */
export function RenderModeChip(props: { mode: RenderMode; onReset: () => void }) {
    if (props.mode === 'auto') return null;
    const name = MODE_NAME[props.mode];
    return (
        <Tooltip content="Rendering override · click to reset" placement="bottom">
            <button
                type="button"
                className="ark-render-chip"
                aria-label={`Rendering override: ${name}. Reset to automatic`}
                onClick={props.onReset}
            >
                <Chip tone="warning" size="sm">{name}</Chip>
            </button>
        </Tooltip>
    );
}
